export const VALIDATE_AUTH = 'VALIDATE_AUTH'
export const VALIDATE_AUTH_FULFILLED = 'VALIDATE_AUTH_FULFILLED'
export const VALIDATE_AUTH_REJECTED = 'VALIDATE_AUTH_REJECTED'
/**
 * Use cached auth information to validate if the user session is still valid
 * If headers are passed in they will be used as a fallback if there aren't headers
 * in the store
 * @param {{access-token: string, client: string, expiry: (string|number), uid: string}} [payload]
 */
export const validateAuth = (payload) => ({ type: VALIDATE_AUTH, payload })

export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_FULFILLED = 'SIGN_IN_FULFILLED'
export const SIGN_IN_REJECTED = 'SIGN_IN_REJECTED'
/**
 * Sign in with the provided credentials
 * @param {{email: string, password: string}} payload
 */
export const signIn = (payload) => ({ type: SIGN_IN, payload })

export const SIGN_OUT = 'SIGN_OUT'
/**
 * Signs out the current user
 */
export const signOut = () => {
  return { type: SIGN_OUT }
}

export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_PASSWORD_FULFILLED = 'RESET_PASSWORD_FULFILLED'
export const RESET_PASSWORD_REJECTED = 'RESET_PASSWORD_REJECTED'
/**
 * Request password reset email
 * @param {{email: string}} payload
 */
export const resetPassword = (payload) => ({ type: RESET_PASSWORD, payload })

export const REQUEST_ACCESS = 'REQUEST_ACCESS'
export const REQUEST_ACCESS_FULFILLED = 'REQUEST_ACCESS_FULFILLED'
export const REQUEST_ACCESS_REJECTED = 'REQUEST_ACCESS_REJECTED'
/**
 * Request access for a retailer to a brand
 * @param {{email: string}} payload
 */
export const requestAccess = (payload) => ({ type: REQUEST_ACCESS, payload })

export const GET_JWT_FROM_ACCESS_TOKEN = 'GET_JWT_FROM_ACCESS_TOKEN'
export const GET_JWT_FROM_ACCESS_TOKEN_FULFILLED =
  'GET_JWT_FROM_ACCESS_TOKEN_FULFILLED'
export const GET_JWT_FROM_ACCESS_TOKEN_REJECTED =
  'GET_JWT_FROM_ACCESS_TOKEN_REJECTED'
/**
 * Use cached legacy auth information to retrieve
 * @param {{access-token: string, client: string, expiry: (string|number), uid: string}} [payload]
 */
export const getJWTFromAccessToken = (payload) => ({
  type: GET_JWT_FROM_ACCESS_TOKEN,
  payload,
})

export const SAVE_JWT_TO_COOKIES = 'SAVE_JWT_TO_COOKIES'
export const SAVE_JWT_TO_COOKIES_FULFILLED = 'SAVE_JWT_TO_COOKIES_FULFILLED'
export const SAVE_JWT_TO_COOKIES_REJECTED = 'SAVE_JWT_TO_COOKIES_REJECTED'

/**
 * Stores a JWT base64 string in the browsers cookies.
 * @param {{cookieName: string, token: string, domain: string}} payload
 */
export const saveJWTToCookies = (payload) => ({
  type: SAVE_JWT_TO_COOKIES,
  payload,
})

export const GET_STORED_JWT = 'GET_STORED_JWT'
export const GET_STORED_JWT_FULFILLED = 'GET_STORED_JWT_FULFILLED'
export const GET_STORED_JWT_REJECTED = 'GET_STORED_JWT_REJECTED'

/**
 * Gets a JWT base64 string in the browsers cookies.
 * @param {{cookieName: string}} payload
 */
export const getStoredJWT = (payload) => ({ type: GET_STORED_JWT, payload })

export const CLEAR_JWT = 'CLEAR_JWT'
export const CLEAR_JWT_FULFILLED = 'CLEAR_JWT_FULFILLED'
export const CLEAR_JWT_REJECTED = 'CLEAR_JWT_REJECTED'
/**
 * Clears the current JWT and headers
 * @param {{cookieName: string}} payload
 */
export const clearJWT = (payload) => ({ type: CLEAR_JWT, payload })

export const SET_AUTH_HEADERS = 'SET_AUTH_HEADERS'
/**
 * Sets the current auth headers
 * @param {{headers: object}} payload
 */
export const setAuthHeaders = (payload) => ({ type: SET_AUTH_HEADERS, payload })

export const ADD_JWT_TO_STATE = 'ADD_JWT_TO_STATE'
